var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState, useRef } from "react";
import ArtGeneratorService from "../../services/ArtGeneratorService";
import Accordion from "../Accordion";
import "../../styles/ColorAndLogoStep.css";
;
var PRIMARY_BLACK = "#000000";
function ColorAndLogoStep(_a) {
    var colorCombinationId = _a.colorCombinationId, colorCombinations = _a.colorCombinations, logoFilePath = _a.logoFilePath, onChange = _a.onChange, onLogoPathChange = _a.onLogoPathChange, onValidityChange = _a.onValidityChange, onNext = _a.onNext, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var _b = useState(colorCombinationId), selectedColor = _b[0], setSelectedColor = _b[1];
    var _c = useState(logoFilePath || null), selectedFile = _c[0], setSelectedFile = _c[1];
    var _d = useState(null), fileError = _d[0], setFileError = _d[1];
    var error = useState(null)[0];
    var loading = useState(false)[0];
    var _e = useState(false), isValidColorAndLogo = _e[0], setIsValidColorAndLogo = _e[1];
    var _f = useState(false), validatingLogo = _f[0], setValidatingLogo = _f[1];
    var inputFileRef = useRef(null);
    var colors = useMemo(function () {
        return colorCombinations.map(function (combo) {
            var _a, _b, _c, _d, _e, _f;
            var endpointColor = (_f = (_d = (_b = (_a = combo.colors) === null || _a === void 0 ? void 0 : _a.find(function (c) { return (c === null || c === void 0 ? void 0 : c.toLowerCase()) !== PRIMARY_BLACK; })) !== null && _b !== void 0 ? _b : (_c = combo.colors) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : (_e = combo.colors) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : "#FFFFFF";
            return __assign(__assign({}, combo), { colors: [PRIMARY_BLACK, endpointColor] });
        });
    }, [colorCombinations]);
    useEffect(function () {
        setSelectedColor(colorCombinationId);
    }, [colorCombinationId]);
    useEffect(function () {
        setSelectedFile(logoFilePath || null);
    }, [logoFilePath]);
    useEffect(function () {
        var valid = !!selectedColor && !!selectedFile;
        setIsValidColorAndLogo(valid);
        onValidityChange === null || onValidityChange === void 0 ? void 0 : onValidityChange(valid);
    }, [selectedColor, selectedFile, onValidityChange]);
    function handleClick() {
        var _a;
        if (validatingLogo)
            return;
        (_a = inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    ;
    function handleFileChange(event) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var file, result, err_1, message;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                        if (!file)
                            return [2 /*return*/];
                        if (file.size > 3 * 1024 * 1024) {
                            setFileError("O arquivo excede 3MB.");
                            setSelectedFile(null);
                            onChange(selectedColor, null);
                            onLogoPathChange === null || onLogoPathChange === void 0 ? void 0 : onLogoPathChange(null);
                            if (inputFileRef.current) {
                                inputFileRef.current.value = '';
                            }
                            return [2 /*return*/];
                        }
                        setFileError(null);
                        setValidatingLogo(true);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ArtGeneratorService.validateLogo(file)];
                    case 2:
                        result = _e.sent();
                        if (!result.valid) {
                            setFileError(result.message || "Logo não permitida.");
                            setSelectedFile(null);
                            onChange(selectedColor, null);
                            onLogoPathChange === null || onLogoPathChange === void 0 ? void 0 : onLogoPathChange(null);
                            return [2 /*return*/];
                        }
                        setSelectedFile(file);
                        onChange(selectedColor, file);
                        onLogoPathChange === null || onLogoPathChange === void 0 ? void 0 : onLogoPathChange((_b = result.path) !== null && _b !== void 0 ? _b : null);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _e.sent();
                        message = ((_d = (_c = err_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || "Erro ao validar a logo.";
                        setFileError(message);
                        setSelectedFile(null);
                        onChange(selectedColor, null);
                        onLogoPathChange === null || onLogoPathChange === void 0 ? void 0 : onLogoPathChange(null);
                        return [3 /*break*/, 5];
                    case 4:
                        setValidatingLogo(false);
                        if (inputFileRef.current) {
                            inputFileRef.current.value = '';
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function handleColorChange(e) {
        var newColor = e.target.value;
        setSelectedColor(newColor);
        onChange(newColor, selectedFile);
    }
    ;
    function getUploadLabel() {
        if (validatingLogo)
            return "Validando logo...";
        if (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name)
            return selectedFile.name;
        return "Clique para inserir sua logo";
    }
    return (_jsxs(Accordion, __assign({ title: "Escolher cores e logotipo", name: "colorCombinationId", step: 4, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [loading && _jsx("p", { children: "Carregando..." }), error && _jsx("p", __assign({ className: "error-message" }, { children: error })), !loading && !error && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "form-group" }, { children: _jsxs("select", __assign({ className: "select-art-generator-default", value: selectedColor, onChange: handleColorChange }, { children: [_jsx("option", __assign({ value: "", disabled: true }, { children: "Selecionar cores" })), colors.map(function (color) { return (_jsx("option", __assign({ value: String(color.id) }, { children: color.name }), color.id)); })] })) })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("span", __assign({ className: "logo-label" }, { children: "Sua logo" })), _jsx("button", __assign({ type: "button", onClick: handleClick, className: "custom-file-upload", style: {
                                    cursor: validatingLogo ? "wait" : "pointer",
                                    opacity: validatingLogo ? 0.6 : 1,
                                    pointerEvents: validatingLogo ? "none" : "auto",
                                } }, { children: _jsx("span", { children: getUploadLabel() }) })), _jsx("p", __assign({ className: "file-upload-info" }, { children: "SVG, PNG, JPG (m\u00E1x. 3MB)" })), fileError && _jsx("p", __assign({ className: "file-error" }, { children: fileError }))] })), _jsx("input", { type: "file", accept: "image/*", ref: inputFileRef, onChange: handleFileChange, style: { display: "none" } })] })), _jsx("div", __assign({ className: "step-footer" }, { children: _jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: !isValidColorAndLogo || validatingLogo }, { children: "Continuar" })) }))] })));
}
export default ColorAndLogoStep;
